import { render, staticRenderFns } from "./GerenciamentoServicoListFiltroModalItemInput.vue?vue&type=template&id=1b80193c"
import script from "./GerenciamentoServicoListFiltroModalItemInput.vue?vue&type=script&lang=js"
export * from "./GerenciamentoServicoListFiltroModalItemInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports